export const ZIP_REGEX = /^[0-9]{5}$/i;
export const PHONE_NUMBER_REGEX =
  /^(\+42[01]|0){1}\s*(\d){3}\s*(\d){3}\s*(\d){3}$/i; //phone number in format +421901234567, +420901234567, 0901234567
export const CITY_REGEX =
    /^([\s]|[a-zA-Z0-9\-]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u01FF]|[\u0200-\u02AF]|[\u0300-\u036F]|[\u1E00-\u1EFF]|[\u2160-\u2188]){2,100}$/i;


export const CART_STEPS = ["/kosik","/kosik/kontakt", "/kosik/doprava-a-platba"]

export const CART_ITEM_TYPE_NORMAL = 1;
export const CART_ITEM_TYPE_VIRTUAL = 2;

export const PARAMETER_HASH_HIDDEN_FRONTEND = 'HIDDEN_FRONTEND';

export const FACEBOOK_SIGNIN_ENABLED = 'facebook_login_enabled';
export const GOOGLE_SIGNIN_ENABLED = 'google_login_enabled';
export const APPLE_SIGNIN_ENABLED = 'apple_signin_enabled';
export const APPLE_SIGNIN_CLIENT_ID = 'apple_signin_client_id';

export const PROJECT_BLOG_TAG = 'project';

export const PROJECT_GALLERY_TOP_HASH = 'PROJECT_GALLERY_TOP';
export const PROJECT_GALLERY_BOTTOM_HASH = 'PROJECT_GALLERY_BOTTOM';
export const PROJECT_VIDEO_TOP_HASH = 'PROJECT_VIDEO_TOP';
export const PROJECT_VIDEO_BOTTOM_HASH = 'PROJECT_VIDEO_BOTTOM';


export const BANNER_BG_COLOR_PARAM = 'GAMS_BANNER_BG_COLOR';
